import { axiosInstance } from "../axios";

export const hangHoaApi = {
  getAll: async (params) => {
    return await axiosInstance.get("/goods", { params });
  },
  getMenuByGoodsCode: async (code) => {
    return await axiosInstance.get(`/goods/${code}/menus`);
  },
  updateMenuByGoodsCode: async (code, body) => {
    return await axiosInstance.put(`/goods/${code}/menus`, body);
  },
  getByCode: async (code) => {
    return await axiosInstance.get(`/goods/${code}`);
  },
  getById: async (id) => {
    return await axiosInstance.get(`/goods/${id}`);
  },
  updatePrice: async (code, body) => {
    return await axiosInstance.put(`/goods/${code}/price`, body);
  },
  updateInfo: async (code, body) => {
    return await axiosInstance.put(`/goods/${code}`, body);
  },
  updateMaterials: async (code, body) => {
    return await axiosInstance.put(`/goods/${code}/materials`, body);
  },
  getPriceReports: async (params) => {
    return await axiosInstance.get("/goods/price-adjustment", { params });
  },
  exportPriceReports: async (params) => {
    return await axiosInstance.get("/goods/price-adjustment/export", {
      params,
      responseType: "blob",
    });
  },
  getMaterialReports: async (params) => {
    return await axiosInstance.get("/goods/material-adjustment", { params });
  },
  exportMaterialReports: async (params) => {
    return await axiosInstance.get("/goods/material-adjustment/export", {
      params,
      responseType: "blob",
    });
  },
  updateStatus: async (code) => {
    return await axiosInstance.put(`/goods/${code}/status`);
  },
  getStoresByCode: async (code) => {
    return await axiosInstance.get(`/goods/${code}/stores`);
  },
  updateStoresByCode: async (code, body) => {
    return await axiosInstance.put(`/goods/${code}/stores`, body);
  },

  //#region Điều chỉnh giá
  getChangePriceList: (params) =>
    axiosInstance.get("/goods-price-confirmations", { params }),
  createChangePrice: (data) =>
    axiosInstance.post("/goods-price-confirmations", data),
  getChangePriceById: (id) =>
    axiosInstance.get(`/goods-price-confirmations/${id}`),
  approveChangePrice: (id, data) =>
    axiosInstance.put(`/goods-price-confirmations/${id}/approve`, data),
  //#endregion
};
